/**
 * Portal Manta · AdicionarBasePage
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { S } from '../../globals.js';
import { loadKbExtras } from '../../app-globals.js';
import { NovoOrcAdicionarTab } from './NovoOrcAdicionarTab.jsx';

const AdicionarBasePage = memo(function AdicionarBasePage_Inner(){
  const [kbExtras, setKbExtras] = useState(()=>loadKbExtras());
  return (<div style={S.page}>
    <div style={S.h1}>📥 06 · Adicionar à Base de Casos</div>
    <div style={S.sub}>Cadastrar caso real (orçamento histórico) que entra automaticamente no Novo Estudo (similaridade)</div>
    <NovoOrcAdicionarTab kbExtras={kbExtras} setKbExtras={setKbExtras}/>
  </div>);
});

export { AdicionarBasePage };
export default AdicionarBasePage;
